import { z } from 'zod';

export const AssessedRiskLevelSchema = z.enum(['LOW', 'MEDIUM', 'HIGH', 'UNASSESSED']);
export const RiskLevelSchema = z.enum(['LOW', 'MEDIUM', 'HIGH', 'PENDING', 'UNASSESSED']);
export type RiskLevel = z.infer<typeof RiskLevelSchema>;
export const RiskLevel = RiskLevelSchema.enum;
